module.exports = __webpack_public_path__ + "img/emba_dy_c.a4154df2.png";